import React, { useEffect, useState } from "react";
import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { IoIosArrowBack } from "react-icons/io";

function Add_Product_Edit_Layout() {
  const Nav = useNavigate();
  return (
    <div>
      <div className="px-3 my-5 w-full font-inter">
        <h1 className="text-2xl mb-5   font-semibold text-[#667085]">
          Products
        </h1>
        <hr />
        <div className="mt-10">
          <h1 className="md:text-mg lg:text-lg w-fit max-lg:text-xl flex justify-start items-center cursor-pointer font-semibold text-[#667085]">
            <NavLink
              className={"flex justify-start items-center"}
              onClick={() =>
                Nav("/admin-dashboard/product-module/add-products")
              }
            >
              <IoIosArrowBack /> Home
            </NavLink>
          </h1>
        </div>
      </div>
      <Outlet />
    </div>
  );
}

export default Add_Product_Edit_Layout;
